<template>
  <span>
    <slot v-if="granted"></slot>
    <span v-else-if="adminOverride" class="adminOverride">
      <v-alert type="info">
        You don't have the "{{ permission }}" permission, but you are still able
        to access this section because you're an 'administrator'
      </v-alert>
      <slot></slot>
    </span>
    <v-alert v-else type="info">
      You do not sufficient permissions to take this action. Try reloading the
      page or contact your admnistrator and ask for the "{{ permission }}"
      permission.
    </v-alert>
  </span>
</template>

<script>
export default {
  name: "currentUserCan",
  props: {
    permission: {
      type: String,
      default: null,
      required: true
    }
  },
  computed: {
    granted() {
      if (!this.permission) {
        return true;
      }
      return this.currentUserCan(this.permission, true);
    },
    adminOverride() {
      return !this.currentUserCan(this.permission, true);
    }
  }
};
</script>

<style>
.adminOverride {
  border: 3px dotted lightgrey;
  display: inline-block;
  box-sizing: border-box;
}
</style>
